<template>
  <b-col md="12" sm="12">
    <b-card no-body v-if="exists">
      <b-card-body class="p-12">
        <h1 v-if="live" tabindex="0">Visualizar Sala de Transmissão</h1>
        <h1 v-if="!live" tabindex="0">Visualizar Transmissão Realizada</h1>
        <b-row v-if="form.id">
          <b-col cols="12">
            <div style="background-color: #FAAF40; padding-top: 5px; padding-bottom: 1px;" v-if="live">
              <p tabindex="0" style="font-size: 16px"><strong>Próxima Transmissão</strong></p>
            </div>
            <b-card v-if="stream && form.canal == 'F'">
              <div tabindex="0" class='embed-container'>
                <iframe :src="'https://www.facebook.com/plugins/video.php?height=314&href=' + form.url_facebook + '&show_text=false&width=560'" width="560" height="314" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
              </div>
            </b-card>
            <b-card v-if="stream && form.canal == 'Y'">
              <div tabindex="0" class='embed-container'>
                <iframe width="560" height="315" :src="form.url_facebook" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>               
              </div>
            </b-card>
            <b-card tabindex="0" v-if="!stream">
              <a :href="form.url_video" target="_blank">
                <img :src="form.banner" style="width: 100%;" />
              </a>
              <div v-if="!stream">
                <strong>Clique em: </strong> <a :href="form.url_video" target="_blank">{{form.url_video}}</a> 
              </div>
            </b-card>
            <b-card>
              <b-row>
                <b-col tabindex="0" cols="8">
                  <strong>{{ form.titulo_video }}</strong>
                </b-col>
                <b-col tabindex="0" cols="4">
                  <strong>{{ form.data_hora }}</strong>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="form.id && form.permite_comentarios">
          <b-col class="col-sm-12">
            <div style="background-color: #FAAF40; padding-top: 5px; padding-bottom: 1px;">
              <p tabindex="0" style="font-size: 16px">&nbsp;<strong>Mensagens</strong></p>
            </div>
            <b-card style="height: 300px; overflow: auto;">
              <ul v-if="form.comentarios.length > 0">
                <li v-for="comentario in form.comentarios" :key="comentario.id">
                  <p tabindex="0"><strong>{{ comentario.nome }} - {{ comentario.created_at }}</strong></p>
                  <div class="p-3 mb-2 bg-primary text-white" style="border-radius: 10px; width: 50%;">{{ comentario.comentario }}</div>
                </li>
              </ul>
              <ul v-else>
                <li>
                  <i tabindex="0">Nenhuma mensagem.</i>
                </li>
              </ul>
              <b-row>
                <b-col cols="10">
                  <b-form-textarea placeholder="Digite sua mensagem" tabindex="0" id="textarea" rows="3"
                    v-model="comentario"></b-form-textarea>
                </b-col>
                <b-col cols="2" align-self="end">
                  <b-button block variant="success" @click="enviarComentario()">
                    <i class="fa fa-paper-plane-o" aria-hidden="true"></i>&nbsp;&nbsp;<span>Enviar</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <br>
        <b-row v-if="realizadas">
          <b-col cols="12">
            <div style="background-color: #FAAF40; padding-top: 5px; padding-bottom: 1px;">
              <p tabindex="0" style="font-size: 16px"><strong>Transmissões Realizadas</strong></p>
            </div>
              <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th tabindex="0" scope="col">Data da Transmissão</th>
                      <th tabindex="0" scope="col">Título da Transmissão</th>
                      <th tabindex="0" scope="col">Visualizar Vídeo</th>
                    </tr>
                  </thead>
                  <tbody v-if="form.proximas">
                    <tr class="action" v-for="sala in form.proximas" :key="sala.id">
                      <td tabindex="0">{{sala.data_hora}}</td>
                      <td tabindex="0">{{sala.titulo}}</td>
                      <td  style="width: 15%">
                          <b-button class="btn btn-sm btn-secondary action" title="Visualizar Vídeo" @click="visualizarVideo(sala.id)">
                            <i class="fa fa-tv"></i>
                          </b-button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="action">
                      <td tabindex="0" colspan="4">Nenhuma sala cadastrada</td>
                    </tr>
                  </tbody>
              </table>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card no-body class="mx-4" v-if="!exists">
      <b-row>
        <b-col md="12">
          <h4 tabindex="0" style="text-align: center; background-color: #FAAF40;">Nenhuma transmissão sendo apresentada no momento.</h4>
        </b-col>
      </b-row>
    </b-card>
    <b-card no-body class="mx-4" >
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="3">
            <b-button block variant="secondary" @click="navigate('/sala')" v-if="live && can('salatransmissao.index')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
               <b-button block variant="secondary" @click="loadTransmissaoAtual()" v-if="!live">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>

    <b-modal title="Incluir Comentários" size="lg" cancel-title="Cancelar" v-model="modalComentario" @ok="enviarComentario()">
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <h3 tabindex="0" style="color: #339966; margin-bottom: 20px; font-weight: bold; text-align: center">Insira aqui seu Comentário</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col tabindex="0" cols="2">
              <strong>Comentário:</strong>
            </b-col>
            <b-col cols="10">
              <b-form-textarea id="textarea" tabindex="0" rows="8" v-model="comentario"></b-form-textarea>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>
  </b-col>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import {eventType} from '@/components/shared/eventType'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    Pagination,
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      descricao: {
        required
      }
    }
  },
  created () {
    if (!this.can('salatransmissao.assistir')) {
      // this.$router.push('/')
    }

    this.loadTransmissaoAtual()
    this.live = true
  },
  destroyed () {
    clearInterval(this.loopComentarios)
    clearInterval(this.loopTransmissao)
  },
  data () {
    return {
      loading: false,
      form: {
        id: '',
        titulo: '',
        url_video: '',
        url_facebook: '',
        data_hora: '',
        banner: '',
        canal: '',
        proximas: [],
        comentarios: [],
        permite_comentarios: true
      },
      conferencia_id: SessionStorage.get('conferencia_atual_id'),
      stream: true,
      exists: false,
      live: true,
      realizadas: true,
      comentario: '',
      modalComentario: false,
      usuarioAtual: 0,
      disable_buttons: false,
      salvarForm: false,
      loopComentarios: null,
      loopTransmissao: null

    }
  },
  computed: {
    edicoes () {
      return this.$store.state.pagination.getList
    },
    exclusoes () {
      return this.$store.state.pagination.getList
    },
    comentarios () {
      return this.$store.state.pagination.getList
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  methods: {
    loadModalComentarios () {
      this.modalComentario = true
      this.comentario = ''
    },
    visualizarVideo (id) {
      this.form.id = null
      this.form.titulo_video = null
      this.form.url_video = null
      this.form.data_hora = null
      this.form.permite_comentarios = null
      this.form.proximas = []
      this.form.comentarios = []
      clearInterval(this.loopComentarios)
      clearInterval(this.loopTransmissao)
      this.loopComentarios = null
      this.loopTransmissao = null

      this.loadTransmissao(id)
    },
    loadNewComentarios () {
      this.loopComentarios = setInterval(() => this.loadComentarios(), 30000)
    },
    loadNewTransmissao () {
      this.loopTransmissao = setInterval(() => this.loadVerificacaoTransmissao(), 30000)
    },
    loadVerificacaoTransmissao () {
      Vue.http.get('api/salaTransmissao/proxima/transmissao/obter').then(response => {
        let data = response.body.data

        if ((data.id !== 0 && data.id !== this.form.id) || data.aovivo !== this.stream) {   
          clearInterval(this.loopComentarios)
          clearInterval(this.loopTransmissao)      
          this.loadTransmissaoAtual()
        }
      })
    },
    loadComentarios () {
      if (this.form.id) {
        Vue.http.get('api/salaTransmissao/' + this.form.id + '/comentario').then(response => {
          let data = response.body.data

          if (data) {
            this.form.comentarios = data
          }
        })
      }
    },
    loadTransmissao (id) {
      this.exists = false
      Vue.http.get('api/salaTransmissao/assistir/' + id + '/' + this.conferencia_id).then(response => {
        let data = response.body.data

        if (data.transmissaoAtual) {
          this.form.id = data.transmissaoAtual.id
          this.form.titulo_video = data.transmissaoAtual.titulo
          this.form.url_video = data.transmissaoAtual.url_video
          this.form.data_hora = data.transmissaoAtual.data_hora
          this.form.banner = data.transmissaoAtual.banner
          this.form.canal = data.transmissaoAtual.canal
          this.form.permite_comentarios = data.transmissaoAtual.permite_comentarios
          this.form.url_facebook = data.transmissaoAtual.url_facebook
          this.stream = data.transmissaoAtual.aovivo
          this.exists = true
          this.loadNewComentarios()
        }

        if (data.comentarios) {
          this.form.comentarios = data.comentarios
        }
        this.live = false
        this.realizadas = false
      })
    },
    loadTransmissaoAtual () {
      this.exists = false
      Vue.http.get('api/salaTransmissao/assistirTransmissaoConferencia/'+this.conferencia_id).then(response => {
        let data = response.body.data
    
        if (data.transmissaoAtual) {
          this.form.id = data.transmissaoAtual.id
          this.form.titulo_video = data.transmissaoAtual.titulo
          this.form.url_video = data.transmissaoAtual.url_video
          this.form.banner = data.transmissaoAtual.banner
          this.form.canal = data.transmissaoAtual.canal
          this.form.data_hora = data.transmissaoAtual.data_hora
          this.form.permite_comentarios = data.transmissaoAtual.permite_comentarios
          this.form.url_facebook = data.transmissaoAtual.url_facebook
          this.stream = data.transmissaoAtual.aovivo
          this.exists = true
          this.live = true
          this.loadNewComentarios()
          this.loadNewTransmissao()
        }

        if (data.proximasTransmissoes) {
         let listTransmissao=[];
         
         $.each(data.proximasTransmissoes, function(key, value) {
            if(value.conferencia_id && value.conferencia_id == this.conferencia_id)
            listTransmissao.push(value);             
          });   

          this.form.proximas = listTransmissao
        }

        if (data.comentarios) {
          this.form.comentarios = data.comentarios
        }

        this.realizadas = true
      })
    },
    enviarComentario () {
      this.$bvModal.msgBoxConfirm('Confirma o envio do comentário?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          let data = {
            comentario: this.comentario
          }

          Vue.http.post('api/salaTransmissao/' + this.form.id + '/comentario', data).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.modalComentario = false
              this.comentario = ''
              this.loadComentarios()
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.loading = false
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>

<style>
.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; }
.embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/salas/SalaConsulta.vue